import React, { useEffect, useState } from "react";

const testimonials = [
  {
    name: "Ruchi Jhaveri",
    location: "Ahmedabad",
    text: "Excellent & unique collection. Best for gifting. The quality and presentation are truly impressive.",
  },
  {
    name: "Samir Shah",
    location: "Ahmedabad",
    text: "Absolutely loved the antique decor piece I purchased from Legacy Decor. The detailing and finishing are beautiful, and it looks even more elegant in person.",
  },
  {
    name: "Arjun Malhotra",
    location: "Mumbai",
    text: "I bought a beautiful gift set for a housewarming. The packaging was lovely, the product looked premium, and it made a perfect gift.",
  },
  {
    name: "Meera Desai",
    location: "Baroda",
    text: "The collection of wall decor is amazing. I found a beautiful piece for my living room and it completely changed the look of the space.",
  },
  {
    name: "Kajal Mehta",
    location: "Ahmedabad",
    text: "I purchased a beautiful decorative frame and absolutely loved the finish. It looks elegant and adds such a classy touch to my home.",
  },
  {
    name: "Neha Shah",
    location: "Ahmedabad",
    text: "The God idols collection is truly beautiful. The craftsmanship and detailing are excellent, and the piece looks very graceful in my home.",
  },
  {
    name: "Amit Patel",
    location: "Surat",
    text: "I was looking for a special gift and found a beautiful German silver item here. The detailing is impressive and it looks much more premium in person.",
  },
  {
    name: "Dhara Joshi",
    location: "Ahmedabad",
    text: "I purchased a beautiful wall clock from Legacy Decor. It is not just useful but also works as a stunning statement piece in my living room.",
  },
  {
    name: "Sachin Mehra",
    location: "Punjab",
    text: "The Pooja Peti I purchased is beautifully designed and very well finished. It is both practical and elegant, and looks lovely in my pooja space.",
  },
  {
    name: "Pooja Patel",
    location: "Ahmedabad",
    text: "I absolutely loved the wooden decor piece I bought. The craftsmanship gives it a warm and timeless feel that fits beautifully into my home.",
  },
  {
    name: "Nisha Mehta",
    location: "Ahmedabad",
    text: "I purchased silver coins for a family occasion and was very happy with the quality and presentation. A wonderful option for traditional gifting.",
  },
  {
    name: "Bhavna Shah",
    location: "Ahmedabad",
    text: "Legacy Decor has such a beautiful antique collection. I found a unique vintage-style piece that instantly added character and elegance to my home.",
  },
  {
    name: "Anjali Desai",
    location: "Ahmedabad",
    text: "I bought a beautiful metal wall decor piece and loved the design. It looks elegant on the wall and gives the room a sophisticated feel.",
  },
  {
    name: "Aravind Krishnan",
    location: "Bengaluru",
    text: "The decorative candles I purchased were beautiful and perfect for gifting. The designs and presentation make them feel very special and premium.",
  },
  {
    name: "Rahul Mehta",
    location: "Ahmedabad",
    text: "Amazing collection with beautiful designs. I found the perfect gift for a family occasion, and the quality was excellent.",
  },
  {
    name: "Kunal Shah",
    location: "Ahmedabad",
    text: "Great variety of premium home decor and gifting items. The product quality and finishing are impressive.",
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const cardsToShow = 4;

  /* Auto slide */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 4) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  /* Get visible testimonials */
  const getTestimonials = () => {
    return Array.from({ length: cardsToShow }, (_, index) => {
      return testimonials[(current + index) % testimonials.length];
    });
  };

  return (
    <section className="bg-[#faf7f2] px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-6 md:py-10 lg:py-10 sm:py-10 xs:py-8 xxs:py-6  mx-auto">
      {/* ================= HEADING ================= */}
      <div className="text-center mb-12">
        <p className="text-[#b08a57] uppercase tracking-[0.25em] text-sm mb-3">
          Customer Love
        </p>

        <h2 className="font-serif text-3xl md:text-4xl text-[#3d3025]">
          What Our Customers Say
        </h2>

        <div className="w-16 h-[2px] bg-[#b08a57] mx-auto mt-5" />
      </div>

      {/* ================= TESTIMONIAL CARDS ================= */}
      <div className=" mx-auto grid grid-cols-1 sm-grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {getTestimonials().map((testimonial, index) => (
          <div
            key={`${testimonial.name}-${current}-${index}`}
            className="
              bg-white
              rounded-xl
              p-7
              shadow-sm
              border border-[#eee5d9]
              transition-all
              duration-500
              hover:shadow-lg
            "
          >
            {/* Testimonial */}
            <p className="text-gray-600 leading-7 text-sm md:text-base min-h-[100px]">
              {testimonial.text}
            </p>

            {/* Customer */}
            <div className="mt-6 pt-5 border-t border-[#eee5d9]">
              <h3 className="font-semibold text-[#3d3025]">
                {testimonial.name}
              </h3>

              <p className="text-xs text-gray-400 mt-1">
                {testimonial.location}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* ================= DOTS ================= */}
      <div className="flex justify-center gap-2 mt-8">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`
              h-2
              rounded-full
              transition-all
              duration-300
              ${current === index ? "w-7 bg-[#b08a57]" : "w-2 bg-[#d8cbb9]"}
            `}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
